const COOKIE_NAME = 'nt_ban_token';
const STORAGE_KEY = 'nt_ban_token';
const MAX_AGE_SECONDS = 63072000; // 2 years
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function readCookie(name) {
  const parts = (document.cookie || '').split(';');
  for (const part of parts) {
    const trimmed = part.trim();
    if (trimmed.startsWith(`${name}=`)) {
      return decodeURIComponent(trimmed.slice(name.length + 1));
    }
  }
  return '';
}

function writeCookie(token) {
  document.cookie =
    `${COOKIE_NAME}=${encodeURIComponent(token)}` +
    `; Max-Age=${MAX_AGE_SECONDS}` +
    '; Path=/' +
    '; Secure' +
    '; SameSite=Lax';
}

function readStorage() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || '';
  } catch (err) {
    return '';
  }
}

function writeStorage(token) {
  try {
    window.localStorage.setItem(STORAGE_KEY, token);
  } catch (err) {
    // Ignore storage failures.
  }
}

function createToken() {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const random = (Math.random() * 16) | 0;
    const value = character === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}

export function getBanToken() {
  const savedToken = readCookie(COOKIE_NAME) || readStorage();
  const token = UUID_PATTERN.test(savedToken) ? savedToken : createToken();
  writeCookie(token);
  writeStorage(token);
  return token;
}

export function persistBanToken(token) {
  if (!token) {
    return;
  }
  writeCookie(token);
  writeStorage(token);
}

export async function enforceBanTokenIfPresent() {
  const token = getBanToken();

  const response = await fetch('/api/v1/ban-ip/enforce', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
    credentials: 'same-origin',
  });

  if (!response.ok) {
    return { banned: false };
  }

  const data = await response.json();
  if (data?.token) {
    persistBanToken(data.token);
  }
  return data;
}
